import { render, staticRenderFns } from "./VirtualServicePropertyPanel.vue?vue&type=template&id=fbf5932a&"
import script from "./VirtualServicePropertyPanel.vue?vue&type=script&lang=js&"
export * from "./VirtualServicePropertyPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VListItemTitle,VTextField})
